import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, Show, TS_Loader } from '@nu-art/thunderstorm-frontend/index';
import { displayMode_Form, displayMode_FreeText, displayMode_Search, stepStatus_NotSubmitted, stepStatus_Submitted, stepStatus_Submitting } from '@app/advisor-shared';
import { ICONS } from '@app/styles';
import './Component_AdvisorWizard_Step.scss';
import { Component_AdvisorWizard_Step_FreeText } from '../Component_AdvisorWizard_Step_FreeText/Component_AdvisorWizard_Step_FreeText.js';
import { Component_AdvisorWizard_Step_Search } from '../Component_AdvisorWizard_Step_Search/Component_AdvisorWizard_Step_Search.js';
import { filterInstances } from '@nu-art/ts-common';
import { ModuleFE_Advisor_AdvisorSnippet } from '@app/advisor-frontend';
import { fillDefaultFormVariables, snippetHasVariablesWithDefaultValues } from './utils.js';
export class Component_AdvisorWizard_Step extends ComponentSync {
    searchRef = React.createRef();
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.wizardStep = nextProps.wizardStep;
        state.stepData = nextProps.stepData;
        state.wizardData = nextProps.wizardData;
        state.stepData.setOnChanged(async () => this.forceUpdate());
        state.hideTitle = !!nextProps.hideTitle;
        state.snippets = filterInstances(state.wizardStep.snippets.map(snippet => ModuleFE_Advisor_AdvisorSnippet.cache.unique(snippet.snippetId)));
        state.hasDefaultValues = state.snippets.some(snippet => snippetHasVariablesWithDefaultValues(snippet));
        return state;
    }
    //######################### Logic #########################
    setDisplayMode = (displayMode) => {
        const stepData = this.state.stepData;
        if (stepData.item.displayMode === displayMode)
            return;
        stepData.updateObj({ displayMode });
        //Commenting out, logic for expanding the spotlight on change in the display mode of the step
        // ModuleFE_AdvisorWorkspace.physician.setExpansionState('spotlight', displayMode === displayMode_Form ? ExpansionState_Full : ExpansionState_Opened);
    };
    getAvailableStepCount = () => {
        const step = this.state.wizardStep;
        return (step.formData.isActive ? 1 : 0)
            + (step.searchData.isActive ? 1 : 0)
            + (step.freeTextData.isActive ? 1 : 0);
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'advisor-wizard-step-v2', children: [this.renderHeader(), this.renderContent()] });
    }
    onClickDefaultAll = (snippets) => {
        const editable = this.state.wizardData.editProp('variableData', {});
        snippets.forEach(snippet => {
            fillDefaultFormVariables(editable, snippet);
        });
        // force the
        this.searchRef.current?.forceCreateAdapter();
    };
    renderHeader = () => {
        const step = this.state.wizardStep;
        const { snippets, hasDefaultValues } = this.state;
        const status = this.state.stepData.get('status');
        const showLabel = !!step.label && !this.state.hideTitle;
        const showButtons = status === stepStatus_NotSubmitted && this.getAvailableStepCount() !== 1;
        const showLoader = status === stepStatus_Submitting;
        const showSubmitted = status === stepStatus_Submitted;
        const searchMode = this.state.stepData.get('displayMode') === 'search';
        //If nothing to show, return here
        if (!showLabel && !showButtons && !showLoader && !showSubmitted && !hasDefaultValues)
            return;
        return _jsx(LL_H_C, { className: 'advisor-wizard-step__header', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: showLabel, children: _jsx("div", { className: 'advisor-wizard-step__header__title', children: step.label }) }), _jsx(Show.If, { condition: hasDefaultValues && searchMode, children: _jsx(Button, { variant: 'secondary', onClick: e => {
                                e.stopPropagation();
                                this.onClickDefaultAll(snippets);
                            }, children: "Default All" }) }), _jsx(Show.If, { condition: showButtons, children: this.renderDisplayModeButtons() }), _jsx(Show.If, { condition: showLoader, children: _jsx(TS_Loader, { className: 'step-status-loader' }) }), _jsx(Show.If, { condition: showSubmitted, children: _jsx(ICONS.v.component, { className: 'step-status-icon' }) })] }) });
    };
    renderDisplayModeButtons = () => {
        const step = this.state.wizardStep;
        const displayMode = this.state.stepData.get('displayMode');
        const getClass = (dm) => _className('step-display-mode-icon', dm === displayMode && 'selected');
        return _jsxs(Show, { children: [_jsx(Show.If, { condition: step.freeTextData.isActive, children: _jsx(ICONS.advisor_v5_freeText.component, { className: getClass(displayMode_FreeText), onClick: () => this.setDisplayMode(displayMode_FreeText) }) }), _jsx(Show.If, { condition: step.formData.isActive, children: _jsx(ICONS.advisor_v5_form.component, { className: getClass(displayMode_Form), onClick: () => this.setDisplayMode(displayMode_Form) }) }), _jsx(Show.If, { condition: step.searchData.isActive, children: _jsx(ICONS.advisor_v5_form.component, { className: getClass(displayMode_Search), onClick: () => this.setDisplayMode(displayMode_Search) }) })] });
    };
    renderContent = () => {
        const stepData = this.state.stepData;
        const displayMode = stepData.get('displayMode');
        switch (displayMode) {
            case displayMode_FreeText:
                return _jsx("div", { className: 'advisor-wizard-step__content', children: _jsx(Component_AdvisorWizard_Step_FreeText, { wizardData: this.state.wizardData, stepIndex: this.state.stepData.item.index, editorRef: this.props.scrollRef, scrollRef: this.props.scrollRef }, this.state.wizardStep.label) });
            case displayMode_Form:
            case displayMode_Search:
                return _jsx("div", { className: 'advisor-wizard-step__content', children: _jsx(Component_AdvisorWizard_Step_Search, { wizardData: this.state.wizardData, wizardStep: this.state.wizardStep, stepIndex: this.state.stepData.item.index, scrollRef: this.props.scrollRef, ref: this.searchRef }, this.state.wizardStep.label) });
            default: {
                this.logError(`Missing Implementation for display mode ${displayMode}`);
                return _jsx(_Fragment, {});
            }
        }
    };
}
//# sourceMappingURL=Component_AdvisorWizard_Step.js.map